module.exports = __webpack_public_path__ + "img/产品生产周期@3x.998269c8.png";